import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-about-features-banner',
    standalone: true,
    imports: [CommonModule],
    template: `
    <section class="w-full">
      <!-- BLOQUE SUPERIOR: HERO / BANNER CON IMAGEN DE FONDO Y OVERLAY -->
      <div class="relative w-full min-h-[360px] sm:min-h-[420px] md:min-h-[480px] flex items-center justify-center overflow-hidden">
        
        <!-- IMAGEN DE FONDO -->
        <img 
          [src]="bgImageUrl" 
          [alt]="title"
          class="absolute inset-0 w-full h-full object-cover object-center"
        />

        <!-- CAPA / OVERLAY DESVANECIENTE (Gradiente morado/rosa a semitransparente) -->
        <div 
          class="absolute inset-0 z-10"
          style="background: linear-gradient(90deg, var(--bg-secondary, #b8629f) 0%, rgba(184, 98, 159, 0.55) 50%, rgba(184, 98, 159, 0.25) 100%);"
        ></div>

        <!-- CONTENIDO CENTRAL DEL HERO -->
        <div class="relative z-20 max-w-4xl mx-auto px-6 py-12 text-center text-white">
          <h2 class="text-3xl sm:text-5xl md:text-6xl font-extrabold tracking-wider uppercase mb-4 drop-shadow-md">
            {{ title }}
          </h2>
          <p class="text-sm sm:text-base md:text-lg font-medium leading-relaxed max-w-3xl mx-auto text-white/95 drop-shadow-sm">
            {{ description }}
          </p>
        </div>

      </div>

      <!-- BLOQUE INFERIOR: BENEFICIOS / CARACTERÍSTICAS -->
      <div class="bg-gray-50/70 py-12 px-4 sm:px-6 md:px-12 border-b border-gray-100">
        <div class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          
          <!-- ITEM 1: PAGOS SEGUROS -->
          <div class="flex flex-col items-center text-center px-4">
            <div 
              class="w-12 h-12 mb-4 flex items-center justify-center rounded-full bg-rose-50"
              style="color: var(--bg-main, #e11d48);"
            >
              <svg class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M3 10h18M7 15h1m4 0h1m-7 4h12a2 2 0 002-2V7a2 2 0 00-2-2H6a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 class="font-bold text-base sm:text-lg text-gray-900 mb-2">
              Pagos 100% seguros
            </h3>
            <p class="text-xs sm:text-base text-gray-600 max-w-xs leading-relaxed">
              Aceptamos Yape y Plin.
            </p>
          </div>

          <!-- ITEM 2: DELIVERY -->
          <div class="flex flex-col items-center text-center px-4">
            <div 
              class="w-12 h-12 mb-4 flex items-center justify-center rounded-full bg-rose-50"
              style="color: var(--bg-main, #e11d48);"
            >
              <svg class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <h3 class="font-bold text-base sm:text-lg text-gray-900 mb-2">
              Delivery Puno
            </h3>
            <p class="text-xs sm:text-base text-gray-600 max-w-xs leading-relaxed">
              Notificaciones de seguimiento en tiempo real.
            </p>
          </div>

          <!-- ITEM 3: FOTOS REALES -->
          <div class="flex flex-col items-center text-center px-4">
            <div 
              class="w-12 h-12 mb-4 flex items-center justify-center rounded-full bg-rose-50"
              style="color: var(--bg-main, #e11d48);"
            >
              <svg class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <h3 class="font-bold text-base sm:text-lg text-gray-900 mb-2">
              Fotos reales de productos reales
            </h3>
            <p class="text-xs sm:text-base text-gray-600 max-w-xs leading-relaxed">
              Fotos de productos reales. Lo que ves, es lo que se entrega.
            </p>
          </div>

        </div>
      </div>
    </section>
  `
})
export class AboutFeaturesBannerComponent {
    @Input() title: string = 'FLORERÍA ROSALINE';
    @Input() description: string = 'Envío de flores, plantas y regalos a domicilio en el mismo día | en Lima y Callao. Sabemos que los detalles mejan la diferencia. Más aún cuando se trata de sorprender a tu persona favorita. Por eso ponemos especial cuidado en toda la experiencia de compra de tu detalle. Desde su armado hasta su entrega.';
    @Input() bgImageUrl: string = 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?q=80&w=1600';
}